import { useQuery } from '@tanstack/react-query'
import {
  CORE_SHELL_MESSAGE_REQUESTS, CORE_SHELL_MESSAGE_SOURCES,
  isLocalizationContext, sourceLocalizationContext, type LocalizationContext,
} from '@solum/experience'
import { LocalizationProvider } from '@solum/ui'
import { useAuth } from '@solum/auth'
import type { ReactNode } from 'react'
import { useSolum } from '../data/client'

export const LOCALIZATION_QUERY_KEY = ['localization', 'shell'] as const

export function ConsoleLocalization({ children }: { children: ReactNode }) {
  const { session } = useAuth()
  const { client, isLive } = useSolum()
  const query = useQuery({
    queryKey: [...LOCALIZATION_QUERY_KEY, session?.user.id ?? 'fixture'],
    enabled: !isLive || Boolean(session),
    queryFn: async (): Promise<LocalizationContext> => {
      if (!isLive) return sourceLocalizationContext()
      const value = await client.resolveMessageContext(CORE_SHELL_MESSAGE_REQUESTS)
      if (!isLocalizationContext(value)) throw new Error('Marble returned an invalid localization context')
      return value
    },
  })
  const state = query.isError ? 'error' : query.data ? 'ready' : 'loading'
  return <LocalizationProvider context={query.data} state={state}
    sourceMessages={CORE_SHELL_MESSAGE_SOURCES} retry={() => { void query.refetch() }}>
    {children}
  </LocalizationProvider>
}
